import { provincias } from "@/config/constants/index";
export default {
  computed: {
    domicilio() {
      let domicilio = this.$store.getters.getConfiguracion().otroDomicilio;
      if (
        this.$store.getters.getConfiguracion().selectDomicilio === "particular"
      ) {
        domicilio = this.$store.getters.getDatosPersonales()
          .domicilioParticular;
      }

      if (domicilio.calle) {
        const calle = domicilio.calle;
        const altura = domicilio.numero;
        const localidad = domicilio.localidad;
        const provincia = provincias.filter(
          prov => prov.value === domicilio.provincia
        );
        return `${calle} ${altura}, ${localidad}, ${provincia[0].label}`;
      }
      return "";
    }
  }
};
